import { queryOptions } from '@tanstack/react-query';
import { HttpService } from '@Services/index';

export interface AuthUserPhoneResponse {
  phoneNumber: string;
  phoneNumberCountryCode: string;
}

export const getAuthUserPhone = async (customerId: string, authorizedUserId: string) => {
  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/phone`;
  const { data } = await HttpService.get<AuthUserPhoneResponse>(url);
  return data;
};

export const getAuthUserPhoneQueryOptions = (customerId: string, authorizedUserId: string) =>
  queryOptions({
    queryKey: ['authUserPhone', customerId, authorizedUserId],
    queryFn: () => getAuthUserPhone(customerId, authorizedUserId),
  });
